// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".datetimepicker[data-v-2bfc6075]{box-sizing:border-box;position:relative}.datetimeform[data-v-2bfc6075]{-webkit-appearance:none;height:100%;width:100%;opacity:0}.datetimeform[data-v-2bfc6075]::-webkit-calendar-picker-indicator{position:absolute;width:100%;height:100%;opacity:0}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
